export default "__VITE_ASSET__Vuzhqky2__"